import React, { forwardRef, ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { Placement, Strategy } from '@floating-ui/react';
import { IStyled } from '../../styles/types';
import { IconWrapper, SvgIcon } from '../Icon';
import { SingleSelect } from '../Dropdown/SingleSelect';
import { theme } from '../../styles/theme';

interface IProps extends IStyled {
  children: ReactNode;
  iconWrapperSize?: number;
  iconSize?: number;
  menuMinWidth?: number;
  disabled?: boolean;
  onOpen?: (event?: Event) => void;
  onClose?: (event?: Event) => void;
  onClick?: (event: SyntheticEvent) => void;
  placement?: Placement;
  strategy?: Strategy;
}

const StyledSvgIcon = styled(SvgIcon)`
  [aria-expanded='true'] & {
    fill: ${theme.colors.mainBlue};
  }
`;

const ActionsMenu = forwardRef<HTMLElement, IProps>(
  (
    {
      children,
      iconWrapperSize = 24,
      iconSize = 20,
      menuMinWidth = 120,
      className,
      disabled,
      onOpen,
      onClose,
      onClick,
      placement,
      strategy,
    },
    ref,
  ) => {
    return (
      <SingleSelect
        ref={ref}
        onOpen={onOpen}
        onClose={onClose}
        onClick={onClick}
        placement={placement}
        strategy={strategy}
        className={className}
        menuMinWidth={menuMinWidth}
        disabled={disabled}
        trigger={
          <IconWrapper size={iconWrapperSize}>
            <StyledSvgIcon
              name="dots-three-outline-vertical"
              width={iconSize}
              height={iconSize}
              style={{ verticalAlign: 'middle' }}
              customFill="currentColor"
              isDisabled={disabled}
            />
          </IconWrapper>
        }
      >
        {children}
      </SingleSelect>
    );
  },
);

export default ActionsMenu;
